import classNames from "classnames"
interface ButtonProps extends React.HTMLProps<HTMLButtonElement> {
  className?: string
  variant: "white" | "inverted-blue" | "blue" | "clear"
  type?: "button" | "submit"
  children: React.ReactNode
}

const Button: React.FC<ButtonProps> = ({
  className: classNameRender,
  variant,
  type,
  children,
  disabled,
  ...props
}) => {
  const componentClassName = classNames(
    classNameRender,
    `button button--${variant}`
  )

  return (
    <>
      <button
        className={componentClassName}
        disabled={disabled ? true : false}
        {...props}
      >
        {children}
      </button>
    </>
  )
}

export { Button }
